/**
 * ar: 阿拉伯语
 * br: 葡萄牙语
 * cn: 简体中文
 * de: 德语
 * en: 英语
 * es: 西语
 * fr: 法语
 * id: 印尼语
 * inn: 印度语
 * it: 意大利语
 * jp: 日语
 * kr: 韩语
 * nl: 荷兰语
 * ru: 俄语
 * tr: 土耳其语
 * tw: 繁体中文
 */

//各语种 SEO站点 首页 链接
const HitPaw_Home_LinkData = {
  ar: 'https://ar.hitpaw.com/',
  br: 'https://online.hitpaw.com.br/',
  cn: '',
  de: 'https://online.hitpaw.de/',
  en: 'https://online.hitpaw.com/',
  es: 'https://online.hitpaw.es/',
  fr: 'https://online.hitpaw.fr/',
  id: 'https://online.hitpaw.id/',
  inn: 'https://online.hitpaw.in/',
  it: 'https://online.hitpaw.it/',
  jp: 'https://online.hitpaw.jp/',
  kr: 'https://online.hitpaw.kr/',
  nl: 'https://online.hitpaw.nl/',
  ru: 'https://online.hitpaw.ru/',
  tr: 'https://tr.hitpaw.com/',
  tw: 'https://online.hitpaw.tw/',
};

//各语种 SEO站点 去水印产品页 链接
const HitPaw_WatermarkRemover_Product_LinkData = {
  ar: 'https://ar.hitpaw.com/remove-watermark.html',
  br: 'https://www.hitpaw.com.br/remove-watermark.html',
  cn: '',
  de: 'https://www.hitpaw.de/remove-watermark.html',
  en: 'https://www.hitpaw.com/remove-watermark.html',
  es: 'https://www.hitpaw.es/remove-watermark.html',
  fr: 'https://www.hitpaw.fr/remove-watermark.html',
  id: 'https://www.hitpaw.id/remove-watermark.html',
  inn: 'https://www.hitpaw.in/remove-watermark.html',
  it: 'https://www.hitpaw.it/remove-watermark.html',
  jp: 'https://www.hitpaw.jp/remove-watermark.html',
  kr: 'https://www.hitpaw.kr/remove-watermark.html',
  nl: 'https://www.hitpaw.nl/remove-watermark.html',
  ru: 'https://www.hitpaw.ru/remove-watermark.html',
  tr: 'https://tr.hitpaw.com/remove-watermark.html',
  tw: 'https://www.hitpaw.tw/remove-watermark.html',
};

//各语种 SEO站点 落地页 链接
const HitPaw_OnlineTools_LinkData = {
  ar: 'https://ar.hitpaw.com/online-tools.html',
  br: 'https://online.hitpaw.com.br/',
  cn: '',
  de: 'https://online.hitpaw.de/',
  en: 'https://online.hitpaw.com/',
  es: 'https://online.hitpaw.es/',
  fr: 'https://online.hitpaw.fr/',
  id: 'https://online.hitpaw.id/',
  inn: 'https://online.hitpaw.in/',
  it: 'https://online.hitpaw.it/',
  jp: 'https://online.hitpaw.jp/',
  kr: 'https://online.hitpaw.kr/',
  nl: 'https://online.hitpaw.nl/',
  ru: 'https://online.hitpaw.ru/',
  tr: 'https://tr.hitpaw.com/online-tools.html',
  tw: 'https://online.hitpaw.tw/',
};

//各语种 SEO站点 HitPaw Toolkit 购买页面 链接
const HitPawToolkit_Buy_LinkData = {
  ar: {
    win: 'https://ar.hitpaw.com/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://ar.hitpaw.com/purchase/buy-hitpaw-toolkit-mac.html',
  },
  br: {
    win: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-toolkit-mac.html',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://www.hitpaw.de/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.de/purchase/buy-hitpaw-toolkit-mac.html',
  },
  en: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.com/purchase/buy-hitpaw-toolkit-mac.html',
  },
  es: {
    win: 'https://www.hitpaw.es/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.es/purchase/buy-hitpaw-toolkit-mac.html',
  },
  fr: {
    win: 'https://www.hitpaw.fr/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.fr/purchase/buy-hitpaw-toolkit-mac.html',
  },
  id: {
    win: 'https://www.hitpaw.id/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.id/purchase/buy-hitpaw-toolkit-mac.html',
  },
  inn: {
    win: 'https://www.hitpaw.in/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.in/purchase/buy-hitpaw-toolkit-mac.html',
  },
  it: {
    win: 'https://www.hitpaw.it/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.it/purchase/buy-hitpaw-toolkit-mac.html',
  },
  jp: {
    win: 'https://www.hitpaw.jp/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.jp/purchase/buy-hitpaw-toolkit-mac.html',
  },
  kr: {
    win: 'https://www.hitpaw.kr/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.kr/purchase/buy-hitpaw-toolkit-mac.html',
  },
  nl: {
    win: 'https://www.hitpaw.nl/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.nl/purchase/buy-hitpaw-toolkit-mac.html',
  },
  ru: {
    win: 'https://www.hitpaw.ru/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.ru/purchase/buy-hitpaw-toolkit-mac.html',
  },
  tr: {
    win: 'https://tr.hitpaw.com/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://tr.hitpaw.com/purchase/buy-hitpaw-toolkit-mac.html',
  },
  tw: {
    win: '',
    mac: '',
  },
};

//各语种 SEO站点 HitPaw Watermark Remover 购买页面 链接
const HitPawWatermarkRemover_Buy_LinkData = {
  ar: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  br: {
    win: 'https://online.hitpaw.com.br/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com.br/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  en: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  es: {
    win: 'https://online.hitpaw.es/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.es/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  fr: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  id: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  inn: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  it: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  jp: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  kr: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  nl: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  ru: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  tr: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  tw: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
};

//各语种 HitPaw Toolkit 安装包 链接
const HitPawToolkit_EXE_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2853.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4321.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2852.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4318.dmg',
  },
  cn: {
    win: '',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4424.dmg',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2847.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4379.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2702.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4288.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2848.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4437.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2849.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4334.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2921.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4428.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_3101.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4414.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2854.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4404.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2850.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4347.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2943.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4299.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_3320.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4344.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2851.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4401.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2947.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4362.dmg',
  },
  tw: {
    win: '',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4386.dmg',
  },
};

//各语种 HitPaw Watermark Remover 安装包 链接
const HitPawWatermarkRemover_EXE_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4308.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4316.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4314.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4315.dmg',
  },
  cn: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4421.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4422.dmg',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4383.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4384.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4285.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4286.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4433.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4435.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4331.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4332.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4441.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4438.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4411.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4412.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4399.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4400.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4343.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4345.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4296.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4297.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4337.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4339.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4376.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4389.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4359.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4360.dmg',
  },
  tw: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-ol_4374.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac-ol_4378.dmg',
  },
};

//各语种 HitPaw Video Editor 安装包 链接
const HitPawVideoEditor_EXE_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4320.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4321.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4317.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4318.dmg',
  },
  cn: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4423.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4424.dmg',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4377.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4379.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4287.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4288.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4436.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4437.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4333.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4334.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4427.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4428.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4413.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4414.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4403.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4404.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4346.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4347.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4298.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4299.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4341.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4344.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4398.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4401.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4361.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4362.dmg',
  },
  tw: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4382.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4386.dmg',
  },
};

//各语种 HitPaw Video Editor 购买 链接
// 注意！！ 因部分小语种量比较小，所以除西语葡语外都暂用英语
// 即：https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html
const HitPawVideoEditor_Buy_LinkData = {
  ar: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  br: {
    win: 'https://online.hitpaw.com.br/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com.br/purchase/buy-hitpaw-video-editor-mac.html',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  en: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  es: {
    win: 'https://online.hitpaw.es/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.es/purchase/buy-hitpaw-video-editor-mac.html',
  },
  fr: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  id: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  inn: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  it: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  jp: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  kr: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  nl: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  ru: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  tr: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
  tw: {
    win: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: 'https://online.hitpaw.com/purchase/buy-hitpaw-video-editor-mac.html',
  },
};

//各语种 HitPaw Video Editor 产品页 链接
const HitPawVideoEdito_Product_LinkData = {
  ar: 'https://ar.hitpaw.com/video-editor.html',
  br: 'https://www.hitpaw.com.br/video-editor.html',
  cn: '',
  de: 'https://www.hitpaw.com/video-editor.html',
  en: 'https://www.hitpaw.com/video-editor.html',
  es: 'https://www.hitpaw.es/video-editor.html',
  fr: 'https://www.hitpaw.fr/video-editor.html',
  id: 'https://www.hitpaw.id/video-editor.html',
  inn: 'https://www.hitpaw.com/video-editor.html',
  it: 'https://www.hitpaw.it/video-editor.html',
  jp: 'https://www.hitpaw.jp/video-editor.html',
  kr: 'https://www.hitpaw.kr/video-editor.html',
  nl: 'https://www.hitpaw.com/video-editor.html',
  ru: 'https://www.hitpaw.com/video-editor.html',
  tr: 'https://www.hitpaw.com/video-editor.html',
  tw: 'https://www.hitpaw.tw/video-editor.html',
};

const HitPaw_Service_LinkData = {
  ar: 'https://ar.hitpaw.com/tools/v2/account.html#/services-policy',
  br: 'https://online.hitpaw.com.br/tools/v2/account.html#/services-policy',
  de: 'https://online.hitpaw.de/tools/v2/account.html#/services-policy',
  en: 'https://online.hitpaw.com/tools/v2/account.html#/services-policy',
  es: 'https://online.hitpaw.es/tools/v2/account.html#/services-policy',
  fr: 'https://online.hitpaw.fr/tools/v2/account.html#/services-policy',
  id: 'https://online.hitpaw.id/tools/v2/account.html#/services-policy',
  inn: 'https://online.hitpaw.in/tools/v2/account.html#/services-policy',
  it: 'https://online.hitpaw.it/tools/v2/account.html#/services-policy',
  jp: 'https://online.hitpaw.jp/tools/v2/account.html#/services-policy',
  kr: 'https://online.hitpaw.kr/tools/v2/account.html#/services-policy',
  nl: 'https://online.hitpaw.nl/tools/v2/account.html#/services-policy',
  ru: 'https://online.hitpaw.ru/tools/v2/account.html#/services-policy',
  tr: 'https://tr.hitpaw.com/tools/v2/account.html#/services-policy',
  tw: 'https://online.hitpaw.tw/tools/v2/account.html#/services-policy',
};

const HitPaw_Privacy_LinkData = {
  ar: 'https://ar.hitpaw.com/tools/v2/account.html#/privacy-policy',
  br: 'https://online.hitpaw.com.br/tools/v2/account.html#/privacy-policy',
  de: 'https://online.hitpaw.de/tools/v2/account.html#/privacy-policy',
  en: 'https://online.hitpaw.com/tools/v2/account.html#/privacy-policy',
  es: 'https://online.hitpaw.es/tools/v2/account.html#/privacy-policy',
  fr: 'https://online.hitpaw.fr/tools/v2/account.html#/privacy-policy',
  id: 'https://online.hitpaw.id/tools/v2/account.html#/privacy-policy',
  inn: 'https://online.hitpaw.in/tools/v2/account.html#/privacy-policy',
  it: 'https://online.hitpaw.it/tools/v2/account.html#/privacy-policy',
  jp: 'https://online.hitpaw.jp/tools/v2/account.html#/privacy-policy',
  kr: 'https://online.hitpaw.kr/tools/v2/account.html#/privacy-policy',
  nl: 'https://online.hitpaw.nl/tools/v2/account.html#/privacy-policy',
  ru: 'https://online.hitpaw.ru/tools/v2/account.html#/privacy-policy',
  tr: 'https://tr.hitpaw.com/tools/v2/account.html#/privacy-policy',
  tw: 'https://online.hitpaw.tw/tools/v2/account.html#/privacy-policy',
};

const HitPaw_Online_LinkData = {
  ar: 'https://ar.hitpaw.com/tools/v2/account.html#/purchase',
  br: 'https://online.hitpaw.com.br/tools/v2/account.html#/purchase',
  de: 'https://online.hitpaw.de/tools/v2/account.html#/purchase',
  en: 'https://online.hitpaw.com/tools/v2/account.html#/purchase',
  es: 'https://online.hitpaw.es/tools/v2/account.html#/purchase',
  fr: 'https://online.hitpaw.fr/tools/v2/account.html#/purchase',
  id: 'https://online.hitpaw.id/tools/v2/account.html#/purchase',
  inn: 'https://online.hitpaw.in/tools/v2/account.html#/purchase',
  it: 'https://online.hitpaw.it/tools/v2/account.html#/purchase',
  jp: 'https://online.hitpaw.jp/tools/v2/account.html#/purchase',
  kr: 'https://online.hitpaw.kr/tools/v2/account.html#/purchase',
  nl: 'https://online.hitpaw.nl/tools/v2/account.html#/purchase',
  ru: 'https://online.hitpaw.ru/tools/v2/account.html#/purchase',
  tr: 'https://tr.hitpaw.com/tools/v2/account.html#/purchase',
  tw: 'https://online.hitpaw.tw/tools/v2/account.html#/purchase',
};

console.log('linkData', process.env.REACT_APP_BUILD_ENV_DOCKER);

/*
dockerdev
dockertest
dockerprod
dockerstage
dockeruat
*/
let ENVdocker = process.env.REACT_APP_BUILD_ENV_DOCKER;
let hitpaw = 'hitpaw-test';
if (ENVdocker === 'dockerdev') {
  hitpaw = 'hitpaw-dev';
}
if (ENVdocker === 'dockertest') {
  hitpaw = 'hitpaw-test-docker';
}
if (ENVdocker === 'dockerstage') {
  hitpaw = 'hitpaw-stage';
}
if (ENVdocker === 'dockeruat') {
  hitpaw = 'hitpaw-uat';
}
if (ENVdocker === 'dockerprod') {
  hitpaw = 'hitpaw-prod';
}
const HitPaw_Online_Test_LinkData = {
  // ar: "https://hitpaw-test.afirstsoft.cn/tools/ar/v2/account.html#/purchase",
  ar: 'https://' + hitpaw + '.afirstsoft.cn/tools/ar/v2/account.html#/purchase',
  br: 'https://' + hitpaw + '.afirstsoft.cn/tools/br/v2/account.html#/purchase',
  de: 'https://' + hitpaw + '.afirstsoft.cn/tools/de/v2/account.html#/purchase',
  en: 'https://' + hitpaw + '.afirstsoft.cn/tools/v2/account.html#/purchase',
  es: 'https://' + hitpaw + '.afirstsoft.cn/tools/es/v2/account.html#/purchase',
  fr: 'https://' + hitpaw + '.afirstsoft.cn/tools/fr/v2/account.html#/purchase',
  id: 'https://' + hitpaw + '.afirstsoft.cn/tools/id/v2/account.html#/purchase',
  inn:
    'https://' + hitpaw + '.afirstsoft.cn/tools/in/v2/account.html#/purchase',
  it: 'https://' + hitpaw + '.afirstsoft.cn/tools/it/v2/account.html#/purchase',
  jp: 'https://' + hitpaw + '.afirstsoft.cn/tools/jp/v2/account.html#/purchase',
  kr: 'https://' + hitpaw + '.afirstsoft.cn/tools/kr/v2/account.html#/purchase',
  nl: 'https://' + hitpaw + '.afirstsoft.cn/tools/nl/v2/account.html#/purchase',
  ru: 'https://' + hitpaw + '.afirstsoft.cn/tools/ru/v2/account.html#/purchase',
  tr: 'https://' + hitpaw + '.afirstsoft.cn/tools/tr/v2/account.html#/purchase',
  tw: 'https://' + hitpaw + '.afirstsoft.cn/tools/tw/v2/account.html#/purchase',
};

export {
  HitPaw_Home_LinkData,
  HitPaw_OnlineTools_LinkData,
  HitPawToolkit_Buy_LinkData,
  HitPawToolkit_EXE_LinkData,
  HitPawWatermarkRemover_EXE_LinkData,
  HitPawWatermarkRemover_Buy_LinkData,
  HitPaw_WatermarkRemover_Product_LinkData,
  HitPawVideoEditor_EXE_LinkData,
  HitPawVideoEditor_Buy_LinkData,
  HitPawVideoEdito_Product_LinkData,
  HitPaw_Service_LinkData,
  HitPaw_Privacy_LinkData,
  HitPaw_Online_LinkData,
  HitPaw_Online_Test_LinkData,
};
